import React, { useRef } from "react";
import { useInView } from "framer-motion";
import CountUp from "react-countup";
import { features } from "../features";

export default function CountUpOnView({ 
  end, 
  prefix = "", 
  suffix = "", 
  duration = 1.6, 
  className = "" 
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -10% 0px" });

  if (!features.aiwaveMotion) {
    return <span ref={ref} className={className}>{prefix}{end}{suffix}</span>;
  }

  return (
    <span ref={ref} className={className}>
      {inView ? (
        <CountUp 
          end={end} 
          duration={duration} 
          prefix={prefix} 
          suffix={suffix}
        />
      ) : (
        `${prefix}0${suffix}`
      )}
    </span>
  );
} 